// removed by extract-text-webpack-plugin
module.exports = {"file-input":"file-input__file-input___2ob1C","fileInput":"file-input__file-input___2ob1C","input":"file-input__input___38NfT","choose-btn":"file-input__choose-btn___WZrg3","chooseBtn":"file-input__choose-btn___WZrg3","remove-btn":"file-input__remove-btn___3zhB7","removeBtn":"file-input__remove-btn___3zhB7"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/file-input.css
// module id = 770
// module chunks = 0